/* eslint-disable max-len */
import React from 'react'
import PropTypes from 'prop-types'
import _ from 'lodash'
import I18n from 'translations/i18n'
import { useSelector } from 'react-redux'
import { Grid, Select, Flex } from '@jisr-hr/design-system'
import { Field, useForm, useFormState } from 'react-final-form'
import { required } from 'components/global/form/FormValidations'
import { Typography } from '@jisr-hr/ds'
import {
  format,
  // isAfter,
  // isBefore,
  // isValid,
  differenceInMinutes,
} from 'date-fns'
import { replaceAmPm, isNextDay } from 'components/global/form/formNormalize'
import { Trans } from 'react-i18next'
import useUpdateEffect from 'components/global/hooks/useUpdateEffect'

import ManuallyTime from './ManuallyTime'
import ExistingPunch from './ExistingPunch'
import DisplayPunch from './DisplayPunch'
import { correctTypes } from '../helper'

import { ReactComponent as ErrorIcon } from '../icons/error.svg'

import Styles from '../ProposedCorrectionTime.module.css'

const PunchOption = (props) => {
  const { type: punchType } = props
  const { change } = useForm()
  const { values } = useFormState()
  const { attendance_logs } = useSelector(({ requestDetails }) => requestDetails)
  const { attendance_record } = useSelector(
    ({ employeeAttendanceDetails }) => employeeAttendanceDetails,
  )
  const shifts = attendance_record?.[0]?.employee_shifts
  const isEmptyShifts = _.isEmpty(shifts)
  const {
    in_time,
    out_time,
    in_time_log: noShiftInLog,
    out_time_log: noShiftOutLog,
  } = attendance_record?.[0] || {}
  const { first_in_punch, first_out_punch, second_in_punch, second_out_punch } = values || {}
  const {
    in_time: first_in_time,
    out_time: first_out_time,
    in_time_log: first_in_time_log,
    out_time_log: first_out_time_log,
    shift_start_time: first_shift_start_time,
  } = shifts?.[0] || {}
  const {
    in_time: second_in_time,
    out_time: second_out_time,
    in_time_log: second_in_time_log,
    out_time_log: second_out_time_log,
    shift_start_time: second_shift_start_time,
  } = shifts?.[1] || {}

  const inTime = isEmptyShifts ? in_time : first_in_time
  const outTime = isEmptyShifts ? out_time : first_out_time

  const shiftIndex = shifts?.findIndex(({ id }) => values?.shift === id)
  const firstInTime = first_in_punch || inTime
  const firstOutTime = first_out_punch || outTime
  const secondInTime = second_in_punch || second_in_time
  const secondOutTime = second_out_punch || second_out_time
  const isInNotRecorded =
    !(shiftIndex === 0 || isEmptyShifts ? firstInTime : secondInTime) && punchType === 'out_punch'

  const [type, setType] = React.useState('existing')
  const [isEdit, setIsEdit] = React.useState(true)
  const [manualTime, setManualTime] = React.useState({ time: '', isNext: false })

  const selectedType = correctTypes?.find((option) => option.value === type)

  const handleChange = (v) => {
    change(`${shiftIndex === 0 || isEmptyShifts ? 'first' : 'second'}_${punchType}`, v.punch_time)
    change(punchType, v)
    setIsEdit(false)
  }

  const handleChangeType = (v) => {
    setType(v.value)
    change(punchType, null)
  }

  const handleManualTime = (v, isNext) => {
    setManualTime({
      time: v,
      isNext,
    })
  }

  const validateLogs = () => {
    const times = {
      firstInTime,
      firstOutTime,
      secondInTime,
      secondOutTime,
    }

    const activeShift = shiftIndex <= 0 ? 'first' : 'second'
    const activePunch = punchType === 'in_punch' ? 'In' : 'Out'
    const key = `${activeShift}${activePunch}Time`

    const current_punch = `${activeShift}_${punchType}`

    times[key] = manualTime.time
    times[`${key}NextDay`] = manualTime.isNext

    const logs = {
      first_shift: {
        in: times.firstInTime ? `2000-01-01 ${times.firstInTime}` : null,
        out: times.firstOutTime
          ? `2000-01-${
              (current_punch === 'first_out_punch' &&
                isNextDay(times.firstInTime, times.firstOutTime)) ||
              isNextDay(firstInTime || first_in_time || first_shift_start_time, firstOutTime)
                ? '02'
                : '01'
            } ${times.firstOutTime}`
          : null,
      },
      second_shift: {
        in: times.secondInTime ? `2000-01-01 ${times.secondInTime}` : null,
        out: times.secondOutTime
          ? `2000-01-${
              (current_punch === 'second_out_punch' &&
                isNextDay(times.secondInTime, times.secondOutTime)) ||
              isNextDay(secondInTime || second_in_time || second_shift_start_time, secondOutTime)
                ? '02'
                : '01'
            } ${times.secondOutTime}`
          : null,
      },
    }

    return logs
  }

  const shiftClockValidation = () => {
    let message = ''
    const logs = validateLogs()

    // check for first shift
    if (shiftIndex <= 0) {
      // check for first shift in punch
      if (punchType === 'in_punch') {
        // IN < 1st OUT (IF 1st OUT Recorded)
        if (logs.first_shift.out) {
          const isFirstInMoreThanFirstOut = differenceInMinutes(
            new Date(logs.first_shift.out),
            new Date(logs.first_shift.in),
          )

          if (isFirstInMoreThanFirstOut <= 0) {
            message = {
              message: 'the_proposed_time_overlaps_before',
              values: {
                maxTime: replaceAmPm(format(new Date(logs.first_shift.out), 'hh:mm a')),
              },
            }
          }
          // IN < 2nd IN (IF 2nd IN Recorded)
        } else if (logs.second_shift.in) {
          const isFirstInMoreThanSecondIn = differenceInMinutes(
            new Date(logs.second_shift.in),
            new Date(logs.first_shift.in),
          )

          if (isFirstInMoreThanSecondIn <= 0) {
            message = {
              message: 'the_proposed_time_overlaps_before',
              values: {
                maxTime: replaceAmPm(format(new Date(logs.second_shift.in), 'hh:mm a')),
              },
            }
          }
          // IN < 2nd OUT (IF 2nd OUT Recorded)
        } else if (logs.second_shift.out) {
          const isFirstInMoreThanSecondOut = differenceInMinutes(
            new Date(logs.second_shift.out),
            new Date(logs.first_shift.in),
          )

          if (isFirstInMoreThanSecondOut <= 0) {
            message = {
              message: 'the_proposed_time_overlaps_before',
              values: {
                maxTime: replaceAmPm(format(new Date(logs.second_shift.out), 'hh:mm a')),
              },
            }
          }
        }
      }

      // check for first shift out punch
      if (punchType === 'out_punch') {
        // OUT > 1st IN (IF 1st IN Recorded)
        if (logs.first_shift.in && logs.first_shift.out) {
          const isSecondOutLessThanFirstIn = differenceInMinutes(
            new Date(logs.first_shift.out),
            new Date(logs.first_shift.in),
          )

          if (isSecondOutLessThanFirstIn <= 0) {
            message = {
              message: 'the_proposed_time_overlaps_after',
              values: {
                minTime: replaceAmPm(format(new Date(logs.first_shift.in), 'hh:mm a')),
              },
            }
          }
        }

        // OUT < 2nd IN (IF 2nd IN Recorded)
        if (logs.second_shift.in) {
          const isFirstOutMoreThanSecondIn = differenceInMinutes(
            new Date(logs.second_shift.in),
            new Date(logs.first_shift.out),
          )

          if (isFirstOutMoreThanSecondIn <= 0) {
            message = {
              message: 'the_proposed_time_overlaps_between',
              values: {
                maxTime: replaceAmPm(format(new Date(logs.second_shift.in), 'hh:mm a')),
                minTime: replaceAmPm(format(new Date(logs.first_shift.in), 'hh:mm a')),
              },
            }
          }
          // OUT < 2nd OUT (IF 2nd OUT Recorded)
        } else if (logs.second_shift.out) {
          const isFirstOutMoreThanSecondOut = differenceInMinutes(
            new Date(logs.second_shift.out),
            new Date(logs.first_shift.out),
          )

          if (isFirstOutMoreThanSecondOut <= 0) {
            message = {
              message: 'the_proposed_time_overlaps_between',
              values: {
                maxTime: replaceAmPm(format(new Date(logs.second_shift.out), 'hh:mm a')),
                minTime: replaceAmPm(format(new Date(logs.first_shift.in), 'hh:mm a')),
              },
            }
          }
        }
      }
    }

    // check for second shift
    if (shiftIndex === 1) {
      // check for first shift out punch
      if (punchType === 'in_punch') {
        //  IN > 1st OUT (IF 1st OUT Recorded)
        if (logs.first_shift.out) {
          const isSecondInLessThanFirstOut = differenceInMinutes(
            new Date(logs.second_shift.in),
            new Date(logs.first_shift.out),
          )

          if (isSecondInLessThanFirstOut <= 0) {
            const msg = logs.second_shift.out
              ? 'the_proposed_time_overlaps_between'
              : 'the_proposed_time_overlaps_after'
            message = {
              message: msg,
              values: {
                maxTime: replaceAmPm(format(new Date(logs.second_shift.out), 'hh:mm a')),
                minTime: replaceAmPm(format(new Date(logs.first_shift.out), 'hh:mm a')),
              },
            }
          }
          // IN > 1st IN (IF 1st IN Recorded)
        } else if (logs.first_shift.in) {
          const isSecondInLessThanFirstIn = differenceInMinutes(
            new Date(logs.second_shift.in),
            new Date(logs.first_shift.in),
          )

          if (isSecondInLessThanFirstIn <= 0) {
            const msg = logs.second_shift.out
              ? 'the_proposed_time_overlaps_between'
              : 'the_proposed_time_overlaps_after'
            message = {
              message: msg,
              values: {
                maxTime: replaceAmPm(format(new Date(logs.second_shift.out), 'hh:mm a')),
                minTime: replaceAmPm(format(new Date(logs.first_shift.in), 'hh:mm a')),
              },
            }
          }
        }
        // IN < 2nd OUT(IF 2nd OUT Recorded)
        if (logs.second_shift.out) {
          const isSecondInMoreThanSecondOut = differenceInMinutes(
            new Date(logs.second_shift.out),
            new Date(logs.second_shift.in),
          )

          if (isSecondInMoreThanSecondOut <= 0) {
            message = {
              message: 'the_proposed_time_overlaps_before',
              values: {
                maxTime: replaceAmPm(format(new Date(logs.second_shift.out), 'hh:mm a')),
              },
            }
          }
        }
      }

      if (punchType === 'out_punch') {
        //  OUT > 2nd IN (IF 2nd IN Recorded)
        if (logs.second_shift.in) {
          const isSecondOutLessThanSecondIn = differenceInMinutes(
            new Date(logs.second_shift.out),
            new Date(logs.second_shift.in),
          )

          if (isSecondOutLessThanSecondIn <= 0) {
            message = {
              message: 'the_proposed_time_overlaps_after',
              values: {
                minTime: replaceAmPm(format(new Date(logs.second_shift.in), 'hh:mm a')),
              },
            }
          }
        }
      }
    }

    return message
  }

  const messageError = shiftClockValidation()

  let logId = null

  if (punchType === 'in_punch') {
    logId = isEmptyShifts ? noShiftInLog : null
    logId = shiftIndex === 0 ? first_in_time_log : logId
    logId = shiftIndex === 1 ? second_in_time_log : logId
  } else {
    logId = isEmptyShifts ? noShiftOutLog : null
    logId = shiftIndex === 0 ? first_out_time_log : logId
    logId = shiftIndex === 1 ? second_out_time_log : logId
  }

  const handleMaxMin = () => {
    const maxFirstIn = firstOutTime || secondInTime || secondOutTime
    const minFirstOut = firstInTime
    const maxFirstOut = secondInTime || secondOutTime
    const minSecondIn = firstOutTime || firstInTime
    const maxSecondIn = secondOutTime
    const minSecondOut = secondInTime || firstOutTime || firstInTime

    if (shiftIndex <= 0) {
      return {
        in_time: {
          min: null,
          max: isNextDay(firstInTime || first_shift_start_time, firstOutTime)
            ? '11:59 PM'
            : maxFirstIn,
        },
        out_time: {
          min: minFirstOut,
          max: maxFirstOut,
        },
      }
    }

    return {
      in_time: {
        min: minSecondIn,
        max: isNextDay(secondInTime, secondOutTime) ? '11:59 PM' : maxSecondIn,
      },
      out_time: {
        min: minSecondOut,
        max: null,
      },
    }
  }

  const punchs = handleMaxMin()

  const punchValidation = punchType === 'in_punch' ? punchs.in_time : punchs.out_time

  const typeComponents = {
    existing: (
      <ExistingPunch
        {...props}
        isInNotRecorded={isInNotRecorded}
        handleChange={handleChange}
        minTime={punchValidation.min}
        maxTime={punchValidation.max}
        logId={logId?.id}
        inTime={shiftIndex <= 0 ? firstInTime : secondInTime}
      />
    ),
    manually: (
      <ManuallyTime
        {...props}
        isInNotRecorded={isInNotRecorded}
        punchType={`${shiftIndex === 0 || isEmptyShifts ? 'first' : 'second'}_${punchType}`}
        status={messageError?.message && 'error'}
        time={manualTime.time}
        handleClose={() => setIsEdit(false)}
        handleExit={() => {
          setIsEdit(false)
        }}
        setTime={handleManualTime}
        inTime={shiftIndex <= 0 ? firstInTime : secondInTime}
        error={!!messageError}
      />
    ),
  }

  React.useEffect(() => {
    setType(_.isEmpty(attendance_logs) ? 'manually' : 'existing')
  }, [attendance_logs])

  useUpdateEffect(() => {
    if (punchType === 'in_punch') {
      change('in_punch', null)
    } else {
      change('out_punch', null)
    }

    change('first_in_punch', null)
    change('first_out_punch', null)
    change('second_in_punch', null)
    change('second_out_punch', null)
    setIsEdit(true)
  }, [values.shift])

  return isEdit ? (
    <Flex
      flexCol
      style={{ gap: 8 }}
    >
      <Flex
        flexCol
        className={Styles.punchOption}
      >
        <Grid
          container
          spacing={1}
        >
          <Grid
            item
            xs={type === 'manually' ? 5 : 6}
          >
            <Select
              options={correctTypes}
              value={selectedType}
              onChange={handleChangeType}
              isDisabled={_.isEmpty(attendance_logs) || isInNotRecorded}
            />
          </Grid>
          <Grid
            item
            xs={type === 'manually' ? 7 : 6}
          >
            <Field
              name="correct_time"
              validate={required}
            >
              {() => typeComponents[type]}
            </Field>
          </Grid>
        </Grid>
      </Flex>
      {((type === 'manually' && messageError?.message) || isInNotRecorded) && (
        <Flex
          itemsCenter
          style={{ gap: 10 }}
        >
          <ErrorIcon className={isInNotRecorded && Styles.orangeIcon} />
          <Typography
            text={
              !isInNotRecorded ? (
                <Trans
                  i18nKey={messageError?.message}
                  components={{ span: <span style={{ fontWeight: 700 }} /> }}
                  values={{
                    min: replaceAmPm(messageError?.values?.minTime),
                    max: replaceAmPm(messageError?.values?.maxTime),
                  }}
                />
              ) : (
                I18n.t('propose_clock_in_time_first')
              )
            }
            variant="caption"
            style={{
              color: isInNotRecorded
                ? 'var(--color-base-colors-yellow-600)'
                : 'var(--color-base-colors-red-500)',
            }}
          />
        </Flex>
      )}
    </Flex>
  ) : (
    <DisplayPunch
      {...props}
      handleEdit={() => setIsEdit(true)}
    />
  )
}

PunchOption.propTypes = {
  type: PropTypes.string,
  detail: PropTypes.shape(),
}

export default React.memo(PunchOption)
